export enum TimelineType {
  Crew = 'crew',
  Aircraft = 'aircraft',
  AircraftGroup = 'aircraft_group',
  Contract = 'contract',
  Maintenance = 'maintenance',
}

export enum TimelineView {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  ThreeMonths = '3-Month',
  Year = 'Year',
  TwoWeeks = '2-Week',
  ThreeWeeks = '3-Week',
}
export enum TimelinePeriodSwitch {
  Previous = 'Previous',
  Next = 'Next',
}

export type TimelinePeriodExtension = {
  isRequired: boolean;
  left: boolean;
  right: boolean;
};

export type ContextMenuClickPosition = {
  groupID: string;
  time: number;
};
